<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-ci`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M46 24c0-12.15-9.85-22-22-22S2 11.85 2 24s9.85 22 22 22 22-9.85 22-22zM6 24c0-9.941 8.059-18 18-18s18 8.059 18 18-8.059 18-18 18S6 33.941 6 24zm14-12a7 7 0 017 7h-4a3 3 0 10-6 0v10a3 3 0 106 0h4a7 7 0 11-14 0V19a7 7 0 017-7zm13.488 1.134c-.163-.088-.324-.134-.77-.134h-1.436c-.446 0-.608.046-.77.134a.908.908 0 00-.378.378c-.088.162-.134.324-.134.77v19.436c0 .446.046.607.134.77a.906.906 0 00.378.378c.162.088.324.134.77.134h1.436c.446 0 .607-.046.77-.134a.908.908 0 00.378-.378c.088-.163.134-.324.134-.77V14.282c0-.446-.046-.607-.134-.77a.908.908 0 00-.378-.378z" fill-opacity="1"/></svg>
</template>
<script>

export default {
  name: 'IconCi',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
